import {ParamMap} from '@angular/router';
import {EventsManager} from '../events/events.manager';
import {BenefitPlanTemplateModel, CoverageLevelModel} from '../models/plans.model';

export const hydratePlanSelectionFromUrlIfPresent = (queryParams: ParamMap, eventsManager: EventsManager): void => {
  const practiceId = queryParams.get('practiceId');
  const templateId = queryParams.get('templateId');
  const coverageLevelName = queryParams.get('coverageLevelName');
  const pageName = queryParams.get('pageName');

  if (!practiceId || !templateId || !coverageLevelName || !pageName) {
    return;
  }

  eventsManager.setPlanDetails({practiceId, templateId, pageName});

  const office = eventsManager.getOfficeInfo();
  const template = office?.benefitPlanTemplates?.find(
    (candidate: BenefitPlanTemplateModel) => candidate.benefitPlanTemplateId === templateId
  );
  const level = template?.coverageLevels?.find(
    (candidate: CoverageLevelModel) => candidate.caption === coverageLevelName
  );
  if (template && level) {
    eventsManager.setLevelSelected({...level, planName: template.name});
  }
};
